import { render, staticRenderFns } from "./DialogStandardWorkingPeriodList.vue?vue&type=template&id=6c355c40"
import script from "./DialogStandardWorkingPeriodList.vue?vue&type=script&lang=js"
export * from "./DialogStandardWorkingPeriodList.vue?vue&type=script&lang=js"
import style0 from "./DialogStandardWorkingPeriodList.vue?vue&type=style&index=0&id=6c355c40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports